import { RequestTypeEnum } from "@nlc/shared-types";

import type { MyFilesSearchSchema } from "@/features/my-files/page-search-schema";

const WEBSITE_REQUEST_TYPES = new Set<string>([
  RequestTypeEnum.WEBSITE_DESIGN,
  RequestTypeEnum.WEBSITE_IMPLEMENTATION,
]);

interface BuildMyFilesUrlParams {
  brandId?: "unknown" | null | number;
  projectId?: null | number;
  requestId: number;
  requestType?: null | string;
}

export function toMyFilesRequestType(
  requestType: null | string | undefined,
): MyFilesSearchSchema["requestType"] {
  if (!requestType) return undefined;
  if (WEBSITE_REQUEST_TYPES.has(requestType)) return "website";
  if (requestType === RequestTypeEnum.GRAPHIC) return "graphic";
  if (requestType === RequestTypeEnum.VIDEO) return "video";

  return undefined;
}

export function buildMyFilesUrl({
  brandId,
  projectId,
  requestId,
  requestType,
}: BuildMyFilesUrlParams): string {
  const url = new URL("/my-files", window.location.origin);

  url.searchParams.set("brandId", String(brandId ?? "unknown"));

  if (projectId !== null && projectId !== undefined) {
    url.searchParams.set("projectId", String(projectId));
  }

  url.searchParams.set("requestId", String(requestId));

  const myFilesRequestType = toMyFilesRequestType(requestType);

  if (myFilesRequestType) {
    url.searchParams.set("requestType", myFilesRequestType);
  }

  return url.toString();
}
